
import React from 'react';
import {connect} from 'react-redux';
import { Formik, Field } from 'formik';
import * as yup from 'yup';
import { Form, Row, Col, Collapse, Card} from 'react-bootstrap';
import Stats from '../Stats';
import Income from './Scenario/Income';
import { RadioButton, RadioButtonGroup } from '../Common';
import moment from 'moment';

class Step2 extends React.Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
  handleSubmit(values,props) {
    // console.log('---here are values',values);
    let finalValues = {
        employment: {
            isRetired: values.isClientRetired
        }
    };
    if(values.isClientRetired === 'false'){
        let projectedRetirementDate = moment(values.client.retirementDate,'MM/YYYY');
        finalValues.employment.grossMonthlySalary = values.client.grossMonthlySalary;
        // finalValues.employment.projectedRetirementDate = values.client.retirementDate;
        finalValues.employment.projectedRetirementDate = {
            month: projectedRetirementDate.format('M') - 1,
            year: projectedRetirementDate.format('YYYY')
        }
    };
    if(this.props.client && this.props.client.isMarried === 'true'){
        finalValues.spouse = {
            employment : {
                isRetired: values.isSpouseRetired
            }
        };
        if(values.isSpouseRetired === 'false'){
            let spouseProjectedRetirementDate = moment(values.spouse.retirementDate,'MM/YYYY');
            finalValues.spouse.employment.grossMonthlySalary = values.spouse.grossMonthlySalary;
            // finalValues.spouse.employment.projectedRetirementDate = values.spouse.retirementDate;
            finalValues.spouse.employment.projectedRetirementDate = {
                month: spouseProjectedRetirementDate.format('M') - 1,
                year: spouseProjectedRetirementDate.format('YYYY')
            }
        }
    }
    // console.log(finalValues)
    this.props.upliftState(finalValues,'scenario');
    this.props.nextStep();
    return;
  }

  render() {
      let baseSchema = {
        isClientRetired: yup.string().required('Please select whether retired or not retired'),
        client: yup.object().when('isClientRetired', {
            is: 'false',
            then: yup.object().shape({
                grossMonthlySalary: yup.number().positive().required('Please enter montly salary'),
                retirementDate: yup.string().required('Please enter retirement date')
            })
        }),
        spouse: yup.object().shape().when('isSpouseRetired', {
            is: 'false',
            then: yup.object().shape({
                grossMonthlySalary: yup.number().required('Please enter montly salary'),
                retirementDate: yup.string().required('Please enter retirement date')
            })
        })
      };
     if(this.props && this.props.client && this.props.client.isMarried === 'true'){
         baseSchema.isSpouseRetired =  yup.string().required('Please select whether retired or not retired');
     }
     const schema = yup.object().shape(baseSchema);
    return(

                 <Formik
                    validateOnChange={false}
                    validateOnBlur={false}
                    initialValues={this.props}
                    validationSchema={schema}
                    onSubmit={this.handleSubmit}
                >
                {({
                        handleSubmit,
                        handleChange,
                        handleBlur,
                        setFieldValue,
                        setFieldTouched,
                        values,
                        errors,
                        touched,
                        isSubmitting
                    }) => (
                        <Form noValidate onSubmit={handleSubmit} >
                        <Card className="stepChild">
                            <Card.Header>
                                <Row >
                                      <span style={{'position':'absolute','paddingLeft':'15px'}}><strong>2.</strong></span>
                                    <Col md={"10"} sm={"12"} style={{'paddingLeft':'35px'}}>
                                        {this.props.getStepHeader(2) }
                                    </Col>
                                    <Col md={"2"} sm={"12"}>
                                        <Stats step={2} {...this.props} />
                                    </Col>
                                </Row>
                            </Card.Header>
                            <Collapse in={this.props.isActive}>
                            <Card.Body>
                        <Card>
                            <Card.Header>{values.client.firstName}'s Information</Card.Header>
                            <Card.Body>
                                <Form.Row>
                                    <Form.Group as={Col} controlId="validationFormikisClientRetired">
                                        <RadioButtonGroup
                                            id="radioGroupRetirement"
                                            label=""
                                            value={values.isClientRetired}
                                            error={errors.isClientRetired}
                                            touched={setFieldTouched}
                                            isValid={touched.isClientRetired && !errors.isClientRetired}
                                            isInvalid={errors.isClientRetired}
                                        >
                                            <Field
                                            component={RadioButton}
                                            name="isClientRetired"
                                            id="clientRetired"
                                            expect={'true'}
                                            label="Retired"
                                            onChange={e => {setFieldValue('isClientRetired',e.target.value);
                                            setFieldTouched('isClientRetired',true);}}
                                            />
                                            <Field
                                            component={RadioButton}
                                            name="isClientRetired"
                                            id="clientNotRetired"
                                            expect={'false'}
                                            label="Not Retired"
                                            onChange={e => {setFieldValue('isClientRetired',e.target.value);
                                            setFieldTouched('isClientRetired',true);}}
                                            />
                                        </RadioButtonGroup>
                                    </Form.Group>
                                </Form.Row>
                                {values.isClientRetired === 'false' &&
                                    <Field
                                    component={Income}
                                    handleSubmit={handleSubmit}
                                    handleChange={handleChange}
                                    handleBlur={handleBlur}
                                    setFieldValue={setFieldValue}
                                    setFieldTouched={setFieldTouched}
                                    values={values}
                                    errors={errors }
                                    touched={touched}
                                    isSubmitting={isSubmitting}
                                    type="client" />
                                }
                            </Card.Body>
                        </Card>
                        {this.props.client.isMarried === 'true' &&
                        <div>
                            <br />
                         <Card>
                            <Card.Header>{values.client.spouse.firstName}'s Information</Card.Header>
                            <Card.Body>
                                <Form.Row>
                                    <Form.Group as={Col} controlId="validationFormikisSpouseRetired">
                                    <RadioButtonGroup
                                        id="radioGroup"
                                        value={values.isSpouseRetired}
                                        error={errors.isSpouseRetired}
                                        touched={setFieldTouched}
                                        isValid={touched.isSpouseRetired && !errors.isSpouseRetired}
                                        isInvalid={errors.isSpouseRetired}
                                    >
                                        <Field
                                        component={RadioButton}
                                        name="isSpouseRetired"
                                        id="spouseRetired"
                                        expect={'true'}
                                        label="Retired"
                                        onChange={e => {setFieldValue('isSpouseRetired',e.target.value);
                                        setFieldTouched('isSpouseRetired',true);}}
                                        />
                                        <Field
                                        component={RadioButton}
                                        name="isSpouseRetired"
                                        id="spouseNotRetired"
                                        expect={'false'}
                                        label="Not Retired"
                                        onChange={e => {setFieldValue('isSpouseRetired',e.target.value);
                                        setFieldTouched('isSpouseRetired',true);}}
                                        />
                                        <Form.Control.Feedback >Looks good!</Form.Control.Feedback>
                                        <Form.Control.Feedback type="invalid">
                                        {errors.isSpouseRetired}
                                        </Form.Control.Feedback>
                                    </RadioButtonGroup>
                                    </Form.Group>
                                </Form.Row>
                                {values.isSpouseRetired === 'false' &&
                                    <Field
                                    component={Income}
                                    handleSubmit={handleSubmit}
                                    handleChange={handleChange}
                                    handleBlur={handleBlur}
                                    setFieldValue={setFieldValue}
                                    setFieldTouched={setFieldTouched}
                                    values={values}
                                    errors={errors }
                                    touched={touched}
                                    isSubmitting={isSubmitting}
                                    type="spouse" />
                                }
                            </Card.Body>
                        </Card>
                        </div>
                        }
                        <Form.Row>
                            <Form.Group as={Col} md="12" style={{"padding":"0px","margin":"0px"}} controlId="step2Continue">
                                <Col md={"12"} sm={"12"}>
                                    <br />
                                    <Stats type='continue' step={2} {...this.props} />
                                </Col>
                            </Form.Group>
                        </Form.Row>
                        </Card.Body>
                        </Collapse>
                        </Card>
                        </Form>
                    )}
                    </Formik>
    );
   }
}
const mapStateToProps = (state , ownProps) => {
    let {form} = state.mainState;
    let {client,scenario} = form;
        if(!client.isMarried || client.isMarried === 'false'){
            client.spouse = {};
            scenario.spouse = {employment:{}};
        }
        if(!scenario.employment){
            scenario.employment ={};
        }
        if(!scenario.spouse || !scenario.spouse.employment)
            scenario.spouse = {employment:{}};
        let clientRD = scenario.employment.projectedRetirementDate;
        if(clientRD && typeof clientRD === 'object'){
            clientRD = moment(new Date(clientRD.year,clientRD.month)).format('MM/YYYY')
        }
        let spouseRD = scenario.spouse.employment.projectedRetirementDate;
        if(spouseRD && typeof spouseRD === 'object'){
            spouseRD = moment(new Date(spouseRD.year,spouseRD.month)).format('MM/YYYY');
        }
        return {
            form,
            isMarried:client.isMarried,
            isClientRetired: scenario.employment.isRetired,
            isSpouseRetired: scenario.spouse.employment.isRetired,
            client:{
                ...client,
                isMarried:client.isMarried,
                grossMonthlySalary: scenario.employment.grossMonthlySalary,
                retirementDate: clientRD
            },
            spouse: {
                ...client.spouse,
                firstName: client.spouse.firstName,
                grossMonthlySalary: scenario.spouse.employment.grossMonthlySalary,
                retirementDate: spouseRD
            },
            ...ownProps
        }
  }
 export default connect(
    mapStateToProps,
    null
  )(Step2)
